import React, { createContext, useContext, useState, ReactNode } from 'react';

interface BackButton {
  backButton: string;
  setBackButton: (value: string) => void;
}

const initialBackButtonValue: BackButton = {
  backButton: null,
  setBackButton: () => {},
};

const BackButtonContext = createContext<BackButton>(initialBackButtonValue);
export const useBackButton = () => useContext(BackButtonContext);

interface Props {
  children: ReactNode;
}

export const BackButtonProvider = ({ children }: Props) => {
  const [backButton, setBackButton] = useState<string>(null);

  return (
    <BackButtonContext.Provider value={{ backButton, setBackButton }}>
      {children}
    </BackButtonContext.Provider>
  );
};
